import React from 'react';
import { ContentIconRenderer } from './content-icon-renderer';
import { transformAriToId } from '@atlassian/search-common';
import { ConfluenceResultMeta } from './confluence-result-meta';
import { EventTypeMessage, WORKED_EVENT } from './event-type-message';
export var quickFindConfluenceContentMapper = function quickFindConfluenceContentMapper(_ref) {
  var _item$confluenceEntit, _item$space;
  var item = _ref.node;
  return {
    ari: item === null || item === void 0 ? void 0 : item.id,
    id: transformAriToId((item === null || item === void 0 ? void 0 : item.id) || '', (item === null || item === void 0 ? void 0 : item.type) || ''),
    title: (item === null || item === void 0 ? void 0 : item.title) || '',
    url: (item === null || item === void 0 ? void 0 : item.url) || '',
    meta: /*#__PURE__*/React.createElement(ConfluenceResultMeta, {
      resultContentType: (item === null || item === void 0 ? void 0 : item.type) || '',
      resultAncestors: item === null || item === void 0 || (_item$confluenceEntit = item.confluenceEntity) === null || _item$confluenceEntit === void 0 ? void 0 : _item$confluenceEntit.ancestors,
      resultSpace: item === null || item === void 0 ? void 0 : item.space
    }),
    additionalMeta: item !== null && item !== void 0 && item.lastModified ? /*#__PURE__*/React.createElement(EventTypeMessage, {
      timestamp: item.lastModified,
      eventType: WORKED_EVENT.UPDATED,
      isMyActivityData: false
    }) : '',
    containerId: transformAriToId((item === null || item === void 0 || (_item$space = item.space) === null || _item$space === void 0 ? void 0 : _item$space.id) || 'UNAVAILABLE', 'space'),
    type: "confluence ".concat(item === null || item === void 0 ? void 0 : item.type) || '',
    icon: ContentIconRenderer({
      type: (item === null || item === void 0 ? void 0 : item.type) || '',
      title: item === null || item === void 0 ? void 0 : item.title
    })
  };
};